function saveAuthToCookie(value) {
  const date = expireDate();
  document.cookie = `authToken=${value.authToken};expires=${date};path=/workup-mobile`;
  document.cookie = `userKey=${value.userKey};expires=${date};path=/workup-mobile`;
  document.cookie = `sessionToken=${value.sessionToken};expires=${date};path=/workup-mobile`;
}

function saveUserToCookie(value) {
  const date = expireDate();
  document.cookie = `userData=${value};expires=${date};path=/workup-mobile`;
}

function getTokenFromCookie(tokenName) {
  return getCookie(tokenName);
}

function getUserFromCookie() {
  let data = getCookie('userData');
  return data ? stringToJson(decodeURIComponent(data)) : null;
}

function getCookie(cName) {
  const cookieData = document.cookie.match('(^|;) ?' + cName + '=([^;]*)(;|$)');
  return cookieData ? cookieData[2] : null;
}

function deleteCookie(value) {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  document.cookie = `${value}=;expires=${date.toUTCString()};`;
}

function stringToJson(stringValue) {
  return JSON.parse(stringValue);
}

function expireDate() {
  const date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 시간
  return date;
}

export {
  saveAuthToCookie,
  saveUserToCookie,
  getTokenFromCookie,
  getUserFromCookie,
  deleteCookie,
};
